/** Id da linha "Transição de etapa" na tabela de opção PRÓPRIA de cada automação — espelha o
 *  enum homônimo de ATS.Hub.API.Vendas.Enums.OpcaoTransicaoEtapaEnum. */
export enum OpcaoTransicaoEtapaEnum {
  EmissaoNFe = 1,
  AutorizacaoNFe = 3,
  SaidaEstoque = 5,
  EnvioSeparacao = 4,
  EnvioExpedicao = 4,
  GeracaoPedido = 1,
  ReservaEstoqueOrcamento = 2,
  ReservaEstoquePedido = 3,
  AprovacaoPagamento = 1,
}
